'use strict';
const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = ({viewClass, isEnabled = () => true}) => {
    return createWidgetFactory({
        viewClass,
        modelClass: require('./model'),
        isEnabled,
        methods: {
            setPaymentOptions(bookingId, collectionMethods, acceptedCreditCardTypeCodes) {
                this.htmlWidgetsFromJsp.getOneClickCheckout().execute('setPaymentOptions', bookingId, collectionMethods, acceptedCreditCardTypeCodes);
            },
            setCardData(paymentDetails) {
                this.model.setCardData(paymentDetails);
            },
            setCreditCardTypeCode(creditCardTypeCode) {
                this.htmlWidgetsFromJsp.getOneClickCheckout().execute('setCreditCardTypeCode', creditCardTypeCode);
            },
            togglePaymentForm(info) {
                this.togglePaymentForm(info);
            },
            hideAllLayers() {
                this.hideAllLayers();
            },
            cleanInputs() {
                this.htmlWidgetsFromJsp.getOneClickCheckout().execute('cleanInputs');
            },
            checkout(options) {
                this.model.checkout(options);
            },
            getShoppingBasketId() {
                return this.model.getShoppingBasketId();
            },
            setBundleId(bundleId) {
                this.model.setBundleId(bundleId);
            },
            setBuyerInfo(buyerInfo) {
                this.model.setBuyerInfo(buyerInfo);
            },
            requestAddProductToShoppingBasket(productId) {
                return this.model.requestAddProductToShoppingBasket(productId);
            },
            getAvailableCreditCardsFromShoppingBasket() {
                this.model.getAvailableCreditCards();
            },
            setShoppingBasketId(shoppingBasketId) {
                this.model.setShoppingBasketId(shoppingBasketId);
            },
        },
        name: 'one_click_checkout',
    });
};
